/* eslint-env browser */
import { getActionCreators } from '@aarhus-university/au-lib-react-components/src/components/password/AUPasswordActions';
import { GET_CONTEXT } from '../const';

const actionCreators = {
  getContext: (context) => async (dispatch) => {
    const url = `${window.userRegistrationApiUri}/GetSignupContext?contextName=${context}`;
    const response = await fetch(url);
    const json = await response.json();
    const result = {};
    result[response.ok ? 'context' : 'error'] = json;
    result.status = response.status;
    dispatch({
      type: GET_CONTEXT,
      result,
    });
  },
};

export default { ...actionCreators, ...getActionCreators() };
